<script>
import { Doughnut } from "vue-chartjs";
import ChartDataLabels from "chartjs-plugin-datalabels";

export default {
  extends: Doughnut,
  props: ["data", "height"],
  async mounted() {
    this.renderLineChart();
    console.log("passei mounted");
  },
  methods: {
    renderLineChart: function() {
      this.renderChart(this.data, this.options);
       this.$data._chart.update(0);
      console.log("renderiza chart", this.$data._chart);
      console.log("this.chartdata = ", this.data);
    }
  },
  data() {
    return {
      options: {
        animation : {
          duration : 0
        },        
        layout: {
          padding: {
            left: 20,
            right: 20,
            top: 15,
            bottom: 20
          }
        },
        plugins: {
          datalabels: {
            color: "#000",
            labels: {
              title: {
                align: "bottom"
              }
            }
          }
        },
        legend: {
          display: true,
          position: "right",
          labels: {
            boxWidth: 20
          }
        }
      }
    };
  },
  watch: {
    data: function() {
      console.log("destroy chart", this.$data._chart);
      //this.$data._chart.update();
      this.$data._chart.destroy();
      this.renderLineChart();
    }
    // $props: {
    //   handler() {
    //     console.log('destroy chart',this._chart)
    //    //this._chart.destroy();
    //     this.renderLineChart();
    //   }
    // }
  }
};
</script>